module.exports = __webpack_public_path__ + "static/img/banner44.20af920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner44.jpg
// module id = mWSZ
// module chunks = 6